import React, { useEffect, useState } from "react";
import Sortable from "sortablejs";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { ToastContainer, toast } from "react-toastify"; // Import Toastify
import "react-toastify/dist/ReactToastify.css";
import BASE_URL from "../config"; // ✅ Import BASE_URL
import Loader from "../components/Loader"; // Import Loader component
import axios from "axios";

const columns = ["ON HOLD", "TODO", "DOING", "TO TEST", "DONE", "FINISHED"];
const token = localStorage.getItem("token");

const getCurrentDate = () => new Date().toISOString().split("T")[0];
const MyTasks = () => {
  const [columnsData, setColumnsData] = useState(columns);
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [userData, setUserData] = useState(null);
  const [assignees, setAssignees] = useState([]); // Replace static assignees array
  const [userDetails, setUserDetails] = useState([]); // New state to store both username and ID
  const [projectMap, setProjectMap] = useState({}); // Map projectId -> project_name
  const [allTasks, setAllTasks] = useState([]); // Store all tasks for admin filtering
  const [selectedUserId, setSelectedUserId] = useState(() => {
    const cached = localStorage.getItem("mytasks_selectedUserId");
    return cached ? Number(cached) : null;
  });
  const [adminView, setAdminView] = useState(() => {
    // Set default to "mytasks" instead of "bills"
    return localStorage.getItem("mytasks_adminView") || "mytasks";
  }); // "bills" | null (default to "mytasks")
  const [dropdownValues, setDropdownValues] = useState({}); // { [taskId]: list }
  const [modalTask, setModalTask] = useState(null); // Add state for modal task

const token = localStorage.getItem("token");

useEffect(() => {
  if (token) {
    fetchUserData();
  }
}, []);

useEffect(() => {
  const fetchActiveUsers = async () => {
    try {
      const response = await fetch(`${BASE_URL}api/user/active-users`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch active users");

      const users = await response.json();
      const usernames = users.map((user) => user.username);
      const userDetailsArray = users.map((user) => ({
        id: user.id,
        username: user.username,
      }));

      setAssignees(usernames);
      setUserDetails(userDetailsArray);
    } catch (error) {
      console.error("Error fetching active users:", error);
    }
  };

  fetchActiveUsers();
}, []);

const fetchUserData = async () => {
  try {
    const response = await fetch(`${BASE_URL}api/user/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) throw new Error("Failed to fetch user");

    const data = await response.json();
    setUserData(data);
    fetchTasks(data);
  } catch (error) {
    console.error("Error fetching user:", error);
  }
};

const fetchTasks = async (user) => {
  try {
    const response = await fetch(`${BASE_URL}api/tasks/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) throw new Error("Failed to fetch tasks");

    const taskList = await response.json();
    const filteredTasks =
      user.role === "admin"
        ? taskList
        : user.role === "tester"
        ? taskList.filter((task) => task.assignee !== "63")
        : taskList.filter((task) => task.assignee === String(user.id));

    setTaskData(filteredTasks);
  } catch (error) {
    console.error("Error fetching tasks:", error);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  document.querySelectorAll(".task-list").forEach((el) => {
    new Sortable(el, {
      group: "kanban",
      animation: 150,
      fallbackOnBody: true,
      forceFallback: true,
      swapThreshold: 0.65,
      onEnd: async (evt) => {
        const taskId = evt.item.dataset.id;
        const newList = evt.to.dataset.list;
        const oldList = evt.from.dataset.list;

        if (taskId && newList && oldList !== newList) {
          const payload = { list: newList };
          try {
            const response = await fetch(`${BASE_URL}api/tasks/update/${taskId}`, {
              method: "PUT",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });

            if (response.ok) {
              toast.success("Task updated successfully!");
            } else {
              const errorData = await response.json().catch(() => ({}));
              toast.error(errorData.message || "Failed to update task");
            }

            const task = taskData.find((task) => task.id === parseInt(taskId));
            if (newList === "DONE" && (task.project === "Client" || task.project === "Bill")) {
              const paymentPayload = {
                client_id: task.client_id,
                next_due_date: new Date(task.date).toISOString().split("T")[0],
              };

              try {
                const updateResponse = await axios.put(
                  `${BASE_URL}api/payment/update-status`,
                  paymentPayload,
                  {
                    headers: { Authorization: `Bearer ${token}` },
                  }
                );
                if (updateResponse.status === 200) {
                  toast.success("Payment status updated and new payment record created!");
                } else {
                  toast.error("Failed to update payment status");
                }
              } catch (err) {
                if (err.response?.status === 404) {
                  toast.error("Payment not found. Please check the client ID and due date.");
                } else {
                  toast.error("Error updating payment. Please try again.");
                }
              }
            }
          } catch (err) {
            toast.error("Error updating task.");
          }
        }
      },
    });
  });
}, [taskData]);

useEffect(() => {
  const fetchProjects = async () => {
    try {
      const response = await fetch(`${BASE_URL}api/project/find-all`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Failed to fetch projects");
      const projects = await response.json();
      const map = {};
      projects.forEach((p) => {
        map[String(p.id)] = p.project_name;
      });
      setProjectMap(map);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  fetchProjects();
}, []);


  const handleAddList = () => {
    const col = document.createElement("div");
    col.className = "task-column";

    const titleEl = document.createElement("h5");
    titleEl.textContent = "New List";
    titleEl.setAttribute("contenteditable", "true");
    titleEl.classList.add("editable-title");

    const listEl = document.createElement("div");
    listEl.className = "task-list";
    listEl.dataset.list = "New List";

    const addBtn = document.createElement("button");
    addBtn.className = "btn btn-outline-secondary btn-sm w-100 mt-2";
    addBtn.innerHTML = `<i class="bi bi-plus-circle"></i> Add Task`;
    addBtn.onclick = (e) => handleAddTask(e, "New List");

    const removeBtn = document.createElement("button");
    removeBtn.className = "btn btn-link text-muted";
    removeBtn.innerHTML = `<i class="bi bi-x"></i>`;
    removeBtn.onclick = handleRemoveList;

    const headerDiv = document.createElement("div");
    headerDiv.className = "d-flex justify-content-between align-items-center mb-2";
    headerDiv.appendChild(titleEl);
    headerDiv.appendChild(removeBtn);

    col.appendChild(headerDiv);
    col.appendChild(listEl);
    col.appendChild(addBtn);

    document.getElementById("kanbanBoard").appendChild(col);
    new Sortable(listEl, {
      group: "kanban",
      animation: 150,
      fallbackOnBody: true,
      swapThreshold: 0.65,
    });
    document.getElementById("kanbanBoard").scrollLeft = document.getElementById("kanbanBoard").scrollWidth;
    titleEl.focus();
  };

  const handleAddTask = (e, listName) => {
    const listEl = e.target.closest(".task-column").querySelector(".task-list");

    const card = document.createElement("div");
    card.className = "task-card";
    card.style.borderLeft = "5px solid #0d6efd";

    // Replace editable project input with a dropdown for projects
    // const projectInput = document.createElement("div");
    // projectInput.className = "project-name text-primary";
    // projectInput.contentEditable = true;
    // projectInput.innerText = "[Project]";
    const projectSelect = document.createElement("select");
    projectSelect.className = "form-select form-select-sm project-name text-primary";
    Object.entries(projectMap).forEach(([id, name]) => {
      const option = document.createElement("option");
      option.value = id;
      option.innerText = name;
      projectSelect.appendChild(option);
    });

    const titleInput = document.createElement("strong");
    titleInput.contentEditable = true;
    titleInput.innerText = "[Task Title]";

    const detailInput = document.createElement("textarea");
    detailInput.rows = 2;
    detailInput.className = "form-control form-control-sm mt-1";
    detailInput.style.fontSize = "0.75rem";
    detailInput.style.marginTop = "4px";
    detailInput.style.color = "#666";
    detailInput.placeholder = "[Task Details]";

    const assigneeSelect = document.createElement("select");
    assigneeSelect.className = "form-select form-select-sm";
    userDetails.forEach((user) => {
      const option = document.createElement("option");
      option.value = user.id; // Set user ID as value
      option.innerText = user.username; // Display username
      assigneeSelect.appendChild(option);
    });

    const assigneeLabel = document.createElement("label");
    assigneeLabel.className = "form-label";
    assigneeLabel.innerText = "Assignee";

    const assigneeDiv = document.createElement("div");
    assigneeDiv.className = "mt-2";
    assigneeDiv.appendChild(assigneeLabel);
    assigneeDiv.appendChild(assigneeSelect);

    const dateInput = document.createElement("input");
    dateInput.type = "date";
    dateInput.className = "form-control form-control-sm";
    dateInput.value = getCurrentDate();

    const dateLabel = document.createElement("label");
    dateLabel.className = "form-label";
    dateLabel.innerText = "Due Date";

    const dateDiv = document.createElement("div");
    dateDiv.className = "mt-2";
    dateDiv.appendChild(dateLabel);
    dateDiv.appendChild(dateInput);

    const addButton = document.createElement("button");
    addButton.className = "btn btn-primary btn-sm mt-2";
    addButton.innerText = "Add Task";
    addButton.onclick = async () => {
      addButton.disabled = true; // Disable button
      addButton.innerText = "Adding..."; // Show loader text

      const newTask = {
        title: titleInput.innerText,
        project: projectSelect.value, // Use selected project id
        details: detailInput.value, // <-- Use .value to get textarea content
        assignee: assigneeSelect.value, // Use selected user ID
        date: dateInput.value,
        list: listName,
        color: "#0d6efd",
        img: "https://via.placeholder.com/30",
        textClass: "text-primary",
      };

      try {
        const token = localStorage.getItem("token");

        const response = await fetch(`${BASE_URL}api/tasks/create`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newTask),
        });

        if (response.ok) {
          const addedTask = await response.json();
          setTaskData((prev) => [...prev, addedTask]);
          card.remove(); // Remove input card
          toast.success("Task added successfully!"); // Show success toaster
        } else {
          throw new Error("Failed to add task");
        }
      } catch (err) {
        console.error("Error adding task:", err);
        toast.error("Error adding task."); // Show error toaster
      } finally {
        addButton.disabled = false; // Re-enable button
        addButton.innerText = "Add Task"; // Reset button text
      }
    };

    const removeIcon = document.createElement("i");
    removeIcon.className = "bi bi-x text-muted";
    removeIcon.style.cursor = "pointer";
    removeIcon.style.fontSize = "1.5rem";
    removeIcon.onclick = () => card.remove();

    const footerDiv = document.createElement("div");
    footerDiv.className = "mt-2 d-flex justify-content-between align-items-center";
    footerDiv.appendChild(addButton);
    footerDiv.appendChild(removeIcon);

    card.appendChild(projectSelect);
    // card.appendChild(projectInput);
    card.appendChild(titleInput);
    card.appendChild(detailInput);
    card.appendChild(assigneeDiv);
    card.appendChild(dateDiv);
    card.appendChild(footerDiv);

    listEl.appendChild(card);
    card.scrollIntoView({ behavior: "smooth", block: "end" });
  };

  const handleRemoveList = (e) => {
    const removeBtn = e.target.closest("button");
    if (removeBtn) {
      const taskColumn = removeBtn.closest(".task-column");
      const listEl = taskColumn.querySelector(".task-list");
      if (listEl.children.length === 0) {
        taskColumn.remove();
      }
    }
  };

  // Set admin as default selected and populate their tasks
  useEffect(() => {
    if (userData?.role === "admin" && selectedUserId === null) {
      setSelectedUserId(userData.id);
    }
  }, [userData, selectedUserId]);

  // Fetch all tasks for admin and store in allTasks
  useEffect(() => {
    if (userData?.role === "admin") {
      const fetchAllTasks = async () => {
        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${BASE_URL}api/tasks/all`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          if (!response.ok) throw new Error("Failed to fetch tasks");
          const taskList = await response.json();
          setAllTasks(taskList);
          // Set initial filtered tasks for admin
          setTaskData(taskList.filter(task => String(task.assignee) === String(selectedUserId || userData.id)));
        } catch (error) {
          toast.error("Failed to load tasks. Please try again.");
        } finally {
          setLoading(false);
        }
      };
      fetchAllTasks();
    }
  }, [userData]);

  // When selectedUserId or adminView changes, filter tasks for that user (admin only)
  useEffect(() => {
    if (userData?.role === "admin" && allTasks.length > 0) {
      if (adminView === "bills") {
        // Only show tasks where project is "Bill" and user is admin
        setTaskData(
          allTasks.filter(
            task =>
              String(task.project) === "Bill" &&
              String(task.assignee) === String(userData.id)
          )
        );
      } else if (adminView === "mytasks" || (!adminView && (selectedUserId === null || selectedUserId === undefined || selectedUserId === 0))) {
        // Show tasks assigned to admin where project is not "Bill"
        setTaskData(
          allTasks.filter(
            task =>
              String(task.assignee) === String(userData.id) &&
              String(task.project) !== "Bill"
          )
        );
      } else if (
        selectedUserId !== null &&
        selectedUserId !== undefined &&
        selectedUserId !== 0
      ) {
        setTaskData(allTasks.filter(task => String(task.assignee) === String(selectedUserId)));
      } else {
        setTaskData([]);
      }
    }
  }, [selectedUserId, allTasks, userData, adminView]);

  useEffect(() => {
    // Store dropdown selection in cache
    localStorage.setItem("mytasks_selectedUserId", selectedUserId !== null ? selectedUserId : "");
    localStorage.setItem("mytasks_adminView", adminView || "");
  }, [selectedUserId, adminView]);

  // Sync dropdownValues with taskData
  useEffect(() => {
    const newDropdowns = {};
    taskData.forEach(task => {
      newDropdowns[task.id] = String(task.list);
    });
    setDropdownValues(newDropdowns);
  }, [taskData]);

  return (
    <div className="container py-4 mytasks-bg">
      {loading ? (
        <Loader message="Loading tasks, please wait..." />
      ) : (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2>My Tasks</h2>
            <div className="d-flex align-items-center gap-2">
              {userData?.role === "admin" && (
                <select
                  className="form-select form-select-sm"
                  style={{ minWidth: 180 }}
                  value={
                    adminView === "bills"
                      ? "bills"
                      : adminView === "mytasks"
                        ? "mytasks"
                        : selectedUserId !== null && selectedUserId !== undefined && selectedUserId !== 0
                          ? String(selectedUserId)
                          : "mytasks"
                  }
                  onChange={e => {
                    const val = e.target.value;
                    if (val === "bills") {
                      setAdminView("bills");
                      setSelectedUserId(null);
                      localStorage.setItem("mytasks_adminView", "bills");
                      localStorage.setItem("mytasks_selectedUserId", "");
                    } else if (val === "mytasks") {
                      setAdminView("mytasks");
                      setSelectedUserId(null);
                      localStorage.setItem("mytasks_adminView", "mytasks");
                      localStorage.setItem("mytasks_selectedUserId", "");
                    } else {
                      setAdminView(null);
                      setSelectedUserId(Number(val));
                      localStorage.setItem("mytasks_adminView", "");
                      localStorage.setItem("mytasks_selectedUserId", val);
                    }
                  }}
                >
                  <option value="bills">Bills</option>
                  <option value="mytasks">My tasks</option>
                  {/* Only show users except the admin */}
                  {userDetails
                    .filter(user => user.id !== userData.id)
                    .map((user) => (
                      <option key={user.id} value={String(user.id)}>
                        {user.username} tasks
                      </option>
                    ))}
                </select>
              )}
              {/* <button onClick={handleAddList} className="btn btn-outline-primary btn-sm">
                <i className="bi bi-plus-lg"></i> Add New List
              </button> */}
            </div>
          </div>
          <div className="kanban-board" id="kanbanBoard">
            {(userData?.role === "user"
              ? columnsData.filter(col => col !== "DONE")
              : columnsData
            ).map((col) => {
              // Count tasks for this list/column
              const listCount = (userData?.role === "admin"
                ? taskData.filter((task) => task.list === col)
                : taskData.filter((task) => task.list === col)
              ).length;
              return (
                <div className="task-column" key={col}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 contentEditable suppressContentEditableWarning={true}>
                      {col} <span style={{ color: "#888", fontWeight: "normal" }}>({listCount})</span>
                    </h5>
                  </div>
                  <div className="task-list" data-list={col}>
                    {(userData?.role === "admin"
                      ? taskData
                        .filter((task) => task.list === col)
                        .sort((a, b) => {
                          // Show admin's tasks first
                          if (String(a.assignee) === String(userData.id) && String(b.assignee) !== String(userData.id)) return -1;
                          if (String(a.assignee) !== String(userData.id) && String(b.assignee) === String(userData.id)) return 1;
                          return 0;
                        })
                      : taskData.filter((task) => task.list === col)
                    ).map((task, index) => (
                      <div
                        key={index}
                        className="task-card"
                        data-id={task.id}
                        style={{ borderColor: task.color }}
                      >
                        {/* --- Move Task Dropdown (OUTSIDE modal trigger) --- */}
                        <div className="move-list-dropdown" style={{ marginBottom: 4 }}>
                          <select
                            className="form-select form-select-sm"
                            value={dropdownValues[task.id] || String(task.list)}
                            style={{ width: "auto", display: "inline-block", minWidth: 100 }}
                            tabIndex={-1}
                            onClick={e => {
                              e.stopPropagation();
                            }}
                            onMouseDown={e => {
                              e.stopPropagation();
                            }}
                            onFocus={e => {
                              e.stopPropagation();
                            }}
                            onChange={async (e) => {
                              const newList = e.target.value;
                              if (String(newList) === String(task.list)) {
                                setDropdownValues(prev => ({
                                  ...prev,
                                  [task.id]: String(task.list)
                                }));
                                return;
                              }
                              setDropdownValues(prev => ({
                                ...prev,
                                [task.id]: newList
                              }));
                              try {
                                const response = await fetch(`${BASE_URL}api/tasks/update/${task.id}`, {
                                  method: "PUT",
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                  },
                                  body: JSON.stringify({ list: newList }),
                                });
                                if (response.ok) {
                                  setTaskData(prev =>
                                    prev.map(t =>
                                      t.id === task.id ? { ...t, list: newList } : t
                                    )
                                  );
                                  toast.success("Task moved to " + newList);
                                } else {
                                  toast.error("Failed to move task");
                                  setDropdownValues(prev => ({
                                    ...prev,
                                    [task.id]: String(task.list)
                                  }));
                                }
                              } catch {
                                toast.error("Failed to move task");
                                setDropdownValues(prev => ({
                                  ...prev,
                                  [task.id]: String(task.list)
                                }));
                              }
                            }}
                          >
                            {columnsData.map(listName => {
                              // Hide "DONE" option for non-admin users
                              if (listName === "DONE" && userData?.role !== "admin") return null;
                              return (
                                <option key={listName} value={listName}>{listName}</option>
                              );
                            })}
                          </select>
                        </div>
                        {/* --- Modal trigger area --- */}
                        <div
                          data-bs-toggle="modal"
                          data-bs-target="#taskModal"
                          style={{ cursor: "pointer" }}
                          onClick={e => {
                            // Only open modal if not clicking on dropdown or its children
                            if (
                              e.target.tagName === "SELECT" ||
                              e.target.tagName === "OPTION" ||
                              e.target.closest(".move-list-dropdown")
                            ) {
                              e.stopPropagation();
                              e.preventDefault();
                              return false;
                            }
                            // Set modal task state
                            setModalTask({
                              title: task.title,
                              project: projectMap[String(task.project)] || "Unknown Project",
                              date: new Date(task.date).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              }),
                              details: task.details,
                              assignee: userDetails.find((u) => u.id === parseInt(task.assignee))?.username || "Unknown",
                              id: task.id
                            });
                          }}
                        >
                          <div className={`project-name ${task.textClass}`}>
                            {task.project === "Bill"
                              ? "Bill"
                              : projectMap[String(task.project)] || "Unknown Project"}
                          </div>
                          <strong>{task.title}</strong>
                          <div style={{ fontSize: "0.8rem", color: "#888" }}>
                            Task #{task.id}
                            {task.project === "Bill" && task.website
                              ? (
                                  <>
                                    {" "}
                                    <span style={{ color: "#0d6efd", fontWeight: 500 }}>
                                      {task.website}
                                    </span>
                                  </>
                                )
                              : null}
                          </div>
                          <div className="task-footer mt-2">
                            <a
                              href={`/user-detail?id=${task.assignee}`}
                              title={userDetails.find((u) => u.id === parseInt(task.assignee))?.username || "Unknown"}
                            >
                              <img
                                src={`https://placehold.co/40x40?text=${(userDetails.find((u) => u.id === parseInt(task.assignee))?.username.charAt(0) || "U").toUpperCase()}&font=roboto`}
                                className="assignee-img"
                                title={userDetails.find((u) => u.id === parseInt(task.assignee))?.username || "Unknown"}
                              />
                            </a>
                            <span>
                              {new Date(task.date).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              })}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                    <button
                      className="btn btn-outline-secondary btn-sm w-100 mt-2"
                      onClick={(e) => handleAddTask(e, col)}
                    >
                      <i className="bi bi-plus-circle"></i> Add Task
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
      {/* Modal */}
      <div
        className="modal fade"
        id="taskModal"
        tabIndex="-1"
        aria-labelledby="taskModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="taskModalLabel">Task Details</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <p><strong>Project:</strong> <span>{modalTask?.project || ""}</span></p>
              <p><strong>Task:</strong> <span>{modalTask?.title || ""}</span></p>
              <p><strong>Task Number:</strong> <span>{modalTask?.id || ""}</span></p>
              <p><strong>Assigned to:</strong> <span>{modalTask?.assignee || ""}</span></p>
              <p><strong>Last Modified:</strong> <span>{modalTask?.date || ""}</span></p>
              <p><strong>Details:</strong></p>
              <p>{modalTask?.details || ""}</p>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer /> {/* Add ToastContainer for notifications */}
      <style>{`
        .mytasks-bg { background: #f1f3f5; position: relative; }
        .kanban-board { 
          display: flex; 
          gap: 1rem;
          overflow-x: auto; 
          overflow-y: hidden; /* Prevent vertical scrollbar */
          padding: 1rem 0; 
          font-size: 0.93rem; /* Slightly smaller font */
        }
        .task-column { 
          flex: 0 0 280px; /* Slightly narrower columns */
          background: #fff; 
          border-radius: 0.5rem; 
          padding: 0.65rem; 
          box-shadow: 0 2px 8px rgba(0,0,0,0.05); 
          font-size: 0.93rem; /* Smaller font */
        }
        .task-list { 
          min-height: 80px; 
          padding: 0.4rem 0; 
          font-size: 0.93rem; 
        }
        .task-card { 
          background: #fff; 
          border-left: 5px solid #0d6efd; 
          padding: 0.6rem; 
          margin-bottom: 0.4rem; 
          border-radius: 0.4rem; 
          box-shadow: 0 1px 4px rgba(0,0,0,0.1); 
          cursor: pointer; 
          font-size: 0.93rem; 
        }
        .project-name { 
          font-size: 0.7rem; 
          font-weight: bold; 
          margin-bottom: 0.15rem; 
        }
        .task-footer { 
          display: flex; 
          justify-content: space-between; 
          align-items: center; 
          font-size: 0.8rem; 
          color: #666; 
        }
        .assignee-img { 
          width: 24px; 
          height: 24px; 
          border-radius: 50%; 
          object-fit: cover; 
          border: 1px solid #fff; 
        }
        .editable-title:focus { 
          outline: 2px solid #007bff; 
          background-color: #e9f5ff; 
          padding: 2px 4px; 
          border-radius: 4px; 
        }
        /* Remove display: flex on the root's direct child only for this page */
        #root > div[style*="display: flex"] {
          display: block !important;
        }
        /* Remove width: 100% from the second inner div */
        #root > div[style*="display: flex"] > div[style*="margin-left: 200px"] {
          width: auto !important;
        }
      `}</style>
    </div>
  );
};
export default MyTasks;

